/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Founders_TitleInputs */

const en_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Founders`)
};

const de_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gruender`)
};

const fr_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les fondateurs`)
};

const es_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los fundadores`)
};

const it_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I fondatori`)
};

const nl_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De oprichters`)
};

const pl_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalozyciele`)
};

const fi_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perustajat`)
};

const da_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stifterne`)
};

const sv_about_founders_title = /** @type {(inputs: About_Founders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundarna`)
};

/**
* | output |
* | --- |
* | "The Founders" |
*
* @param {About_Founders_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_founders_title = /** @type {((inputs?: About_Founders_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Founders_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_founders_title(inputs)
	if (locale === "fr") return fr_about_founders_title(inputs)
	if (locale === "es") return es_about_founders_title(inputs)
	if (locale === "it") return it_about_founders_title(inputs)
	if (locale === "nl") return nl_about_founders_title(inputs)
	if (locale === "pl") return pl_about_founders_title(inputs)
	if (locale === "fi") return fi_about_founders_title(inputs)
	if (locale === "da") return da_about_founders_title(inputs)
	if (locale === "sv") return sv_about_founders_title(inputs)
	return en_about_founders_title(inputs)
});